// extracted by mini-css-extract-plugin
export default {"node":"ContactsNode_node__SnVzt","node-title":"ContactsNode_node-title__qEoi9"};